<template>
  <div class="minwidth w100 mw100" style="background-color: #151419;color: #fff;">
    <tabbar></tabbar>

    <div class="positionrel w100">
      <img style="width: 100%;height: auto;-webkit-filter: contrast(90%);filter: contrast(90%);"
        :src="require('../../public/img/main/login_banner.png')" />
    </div>

    <div class="pcScreen" style="width: 30%;margin: 0 auto;padding: 3% 0;font-size: max(10px,1vw);height: 12em;">
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;">
        <div style="width: 20%;">
          账号：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;margin-top: 2%;">
        <div style="width: 20%;">
          密码：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div
        style="width: 60%;margin: 0 auto;text-align: center;background-color: #f8c661;line-height: 2.2;border-radius: 1em;margin-top: 4%;color: #fff;">
        登录
      </div>
      <div style="text-align: center;margin-top: 3%;color: #888888;cursor: pointer;" @click="gotoRegister">
        注册 >>
      </div>
    </div>

    <div class="mobileScreen" style="width: 90%;margin: 0 auto;padding: 3% 0;font-size: 3vw;height: 60vh;">
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;">
        <div style="width: 10%;">
          账号：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div style="width: 100%;margin: 0 auto;display: flex;justify-content: center;align-items: center;margin-top: 2%;">
        <div style="width: 10%;">
          密码：
        </div>
        <input style="width: 50%;display: block;line-height: 1.5;" type="text">
      </div>
      <div
        style="width: 60%;margin: 0 auto;text-align: center;background-color: #f8c661;line-height: 2.2;border-radius: 1em;margin-top: 4%;color: #fff;">
        登录
      </div>
      <div style="text-align: center;margin-top: 3%;color: #888888;cursor: pointer;" @click="gotoRegister">
        注册 >>
      </div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        num: 0,
      };
    },

    mounted() {
      this.num = this.$route.query.num;
    },

    methods: {
      gotoRegister(num) {
        this.$router.push({ path: '/register' })
      }
    },


  };
</script>

<style scoped>
  .w100 {
    width: 100%;
  }
  
  .minwidth {
    min-width: 1000px;
  }

  .flex {
    display: flex;
  }

  .textcent {
    text-align: center;
  }

  .textalign_justify {
    text-align: justify;
    line-height: 25px;
  }

  .fontsize50 {
    font-size: 50px;
  }

  .fontsize30 {
    font-size: 30px;
  }

  .fontsize20 {
    font-size: 20px;
  }

  .fontsize16 {
    font-size: 16px;
  }

  .fontsize14 {
    font-size: 14px;
  }

  .fontsize12 {
    font-size: 12px;
  }

  .fontcolorb0 {
    color: #b0b0b0;
  }

  .margincent {
    margin: 0 auto;
  }

  .margincentY {
    margin: auto 0;
  }

  .margintop50 {
    margin-top: 50px;
  }

  .margintop70 {
    margin-top: 70px;
  }

  .marginleft20 {
    margin-left: 20px;
  }

  .marginbot70 {
    margin-bottom: 70px;
  }

  #job:hover {
    color: #bc9158;
  }

  .positionrel {
    position: relative;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 1920px;
    -webkit-filter: contrast(50%);
    filter: contrast(50%);
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }

    .flexnone {
      display: block;
    }

    .w80 {
      width: 80%;
    }

    .positionrel {
      position: relative;
      overflow: hidden;
    }

    .positionabs {
      position: absolute;
      left: 50%;
      transform: translate(-50%);

      width: 780px;
    }
  }
</style>